export default __webpack_public_path__ + "static/media/103.eab78072.png";